import sistema from '../../config';

function LoginPage(props){
    return (
    <section id="login">
      <div className="col-md-4 col-md-offset-4">
        <div className="login-panel panel panel-default">
            <div className="panel-heading">
                <h3 className="panel-title">BEM VINDO AO SISTEMA {sistema.nome}</h3>
                <p>digite seus dados de acesso</p>
            </div>
            
            <div className="panel-body">
                <form method="POST" onSubmit={props.Submit}>
                    <fieldset>
                        <div className="form-group">
                            <input className="form-control" placeholder="Usuário" value={props.usuario} onChange={(e)=> {props.setUsuario(e.target.value)}} name="usuario" type="text" autoFocus={true}/>
                        </div>
                        
                        <div className="form-group">
                            <input className="form-control" placeholder="********" value={props.senha} onChange={(e) => {props.setSenha(e.target.value)}} name="senha" type="password"/>
                        </div>
                            {props.msg.length > 0  && (<center>{props.msg}</center>)}
                            <button className="btn btn-lg btn-success" style={{marginTop: '10px'}}>ENTRAR</button>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                            <span className="inip"><a href="../../RecuperarSenha">Recuperar senha</a></span>
                            <span className="inip"><a href="../../Cadastre-se">Cadastre-se</a></span>
                            </div>
                            {/* <span className="inip">IP de acesso: {props.ip.length ? props.ip : 'Carregando...'}</span> */}
                            </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </section>	
    );
}

export default LoginPage;
